import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListService } from '@commoncore/services/list.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';

@Injectable({
  providedIn: 'root'
})
export class ShareAccessService {
  public isPublicLink:boolean = false;
  public isSharedFilesView:boolean = false;
  public sortType :string = "";
  public sort :string = "";
  public sharedLinkSortType:string = "sname";
  public singleObjectShared = "";
  public sharedFilesList:any = [];
  public shareKey:any;
  public nextLink:string = "";
  public listsize:number= 0;
  public wrongUlinkPwd : Boolean = false;
  public passwordNeeded: Boolean = false;
  public invalidUnivShareKey : Boolean = false;
  public showUnivShareLinkFiles : Boolean = false;
  public univSharePswd : String = "";
  public univShareKey : String = "";
  currentSharedFolder:any;

  public showShareTabName : any = "";
  public currentOpenFolderName : any = "";

  constructor(public listService:ListService,
    public universalService: UniversalService,
    public localStorageService: LocalStorageSvc,
    private http: HttpClient
    ) {
   }

  shareSortSetting() {
    var classRef = this;
    var localStorage = window.localStorage;
    // if (localStorage.sharedFilesSort == null || localStorage.sharedFilesSort == undefined) {
      
    //   localStorage.setItem('sharedFilesSort', this.currentSort);
    // } else {
    //   this.currentSort = localStorage.sharedFilesSort;
    //   localStorage.setItem('sharedFilesSort', this.currentSort);
    // }
    if(this.listService.getShareListViewSortOrder() == null){
      /*if(this.universalService.isMobileDevice){
        this.listService.listViewSortOrder = "&sort=%2Dsmd";
        this.sortType = 'lastModified';
      }
      else{
        this.listService.listViewSortOrder = "&sort=%2BobjectName";
        this.sortType = '';
      }*/
      this.listService.listViewSortOrder = "&sort=%2Dsmd"; //Added modified date as default sort - 718311
      this.sortType = 'lastModified';
    }
    else{
      this.listService.listViewSortOrderShare = this.listService.getShareListViewSortOrder();
      if(this.universalService.openFolderContent){
        if(this.universalService.isMobileDevice){
          this.sortType = 'lastModified';
        }
        else {
          if(this.listService.listViewSortOrderShare.indexOf('scd')>0){
            this.universalService.showShareCreatedSortShared = this.listService.getShareListViewSortOrder();
            if(this.listService.getShareListViewSortOrder().indexOf('%2D')>0){
              this.listService.setShareListViewSortOrder("&sort=%2DobjectName");
            } else {
              this.listService.setShareListViewSortOrder("&sort=%2BobjectName");
            }
          }
          this.sortType = (this.listService.listViewSortOrderShare.indexOf('Name')>0 || this.listService.listViewSortOrderShare.indexOf('scd')>0)? '':'lastModified';
        }
      } 
      if(this.universalService.openFolderContent && this.sortType == 'lastModified')  { 
        if(this.listService.getShareListViewSortOrder().indexOf('%2D')>0){
          this.listService.listViewSortOrder = "&sort=%2Dlmd";//need to check for 2B/2D from localStorage
        }
        else{
          this.listService.listViewSortOrder = "&sort=%2Blmd";//need to check for 2B/2D from localStorage
        }
      }
      else if(!this.universalService.openFolderContent && this.sortType == 'lastModified'){
        if(this.listService.getShareListViewSortOrder().indexOf('%2D')>0){
          this.listService.listViewSortOrder = "&sort=%2Dsmd";//need to check for 2B/2D from localStorage
        }
        else{
          this.listService.listViewSortOrder = "&sort=%2Bsmd";//need to check for 2B/2D from localStorage
        }
      }
      else if(!this.universalService.openFolderContent && this.universalService.showShareCreatedSortShared!=""){
        this.sortType = "shareCreated";
        this.listService.setShareListViewSortOrder(this.universalService.showShareCreatedSortShared);
        this.listService.listViewSortOrder = this.listService.listViewSortOrderShare;
      }
      else if(this.sortType == ''){
        if(this.listService.listViewSortOrderShare.indexOf('Name')>0){
          this.listService.listViewSortOrder = (this.listService.getShareListViewSortOrder().indexOf('%2D')>0)? "&sort=%2DobjectName":"&sort=%2BobjectName";
        }
        else if(this.listService.listViewSortOrderShare.indexOf('scd')>0){
          this.sortType = "shareCreated";
          this.listService.listViewSortOrder = this.listService.listViewSortOrderShare;
        }
        else if(this.listService.listViewSortOrderShare.indexOf('md')>0){
          this.sortType = "lastModified";
          this.listService.listViewSortOrder = this.listService.listViewSortOrderShare;
        }
        else{
          //this.listService.listViewSortOrder = "&sort=%2BobjectName";
          this.listService.listViewSortOrder = "&sort=%2Dsmd"; // Added modified date as default sort - 718311
        }
      }
      else if(this.sortType == "shareCreated"){
        if((this.listService.getShareListViewSortOrder().indexOf('scd')>0)){
          this.listService.listViewSortOrder = (this.listService.getShareListViewSortOrder().indexOf('%2Dscd')>0) ? "&sort=%2Dscd":"&sort=%2Bscd";
        }
        else {
          this.listService.listViewSortOrder = "&sort=%2Dscd";
        }
      }
      else{
        this.listService.listViewSortOrder = this.listService.listViewSortOrderShare;
      }
  }

    this.sort = this.sortType;
    this.listService.setShareListViewSortOrder(this.listService.listViewSortOrder);
  }

  updateSort() {
    // var localStorage = window.localStorage;
    // localStorage.setItem('sharedFilesSort', this.currentSort);
    AppEvents.emit(EventsList.CHANGE_SORT_TYPE_OF_SHARED_FILES)
  }

  removeSortFromLocalStorage(){
    var localStorage = window.localStorage;
    localStorage.removeItem('sharedFilesSort');
  }
}
